<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/tramite-carga">Trámites</router-link>
            > Trámite {{ this.p_idTramite }}
          </div>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
          >
            help
          </span>
        </div>
      </div>
    </div>
    <hr />
    <!-- Modal -->
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <form>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label class="form-label font-weight-bold">Trámite</label>
                </div>
                <div class="col-4">
                  <p class="form-control-plaintext">
                    {{ datoCarga.idTramite }}
                  </p>
                </div>
                <div class="col-2">
                  <label class="form-label font-weight-bold">IdCarga</label>
                </div>
                <div class="col-4">
                  <p class="form-control-plaintext">{{ datoCarga.idCarga }}</p>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label class="form-label font-weight-bold">FechaDesde</label>
                </div>
                <div class="col-4">
                  <p class="form-control-plaintext">
                    {{ datoCarga.fechaDesde }}
                  </p>
                </div>
                <div class="col-2">
                  <label class="form-label font-weight-bold">FechaHasta</label>
                </div>
                <div class="col-4">
                  <p class="form-control-plaintext">
                    {{ datoCarga.fechaHasta }}
                  </p>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label class="form-label font-weight-bold">Obs</label>
                </div>
                <div class="col-10">
                  <p
                    class="form-control-plaintext"
                    style="text-transform: uppercase"
                  >
                    {{ datoCarga.obs }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <br />
      <!-- Estructura de Tabs -->
      <div class="tabs">
        <button
          class="tablink"
          @click="showTable = 'cargaAmbVista'"
          :class="{ 'active-tab': showTable === 'cargaAmbVista' }"
        >
          Datos de Carga
        </button>
      </div>

      <!-- Contenido dinámico según la pestaña seleccionada -->
      <div v-if="showTable === 'cargaAmbVista'">
        <CargaAmbVista
          :p_idTramite="datoCarga.idTramite"
          :p_idCarga="datoCarga.idCarga"
        ></CargaAmbVista>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";
import CargaAmbVista from "../forms/CargaAmbVista.vue";
import { format } from "date-fns";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
export default {
  components: {
    Layout,
    Footer,
    CargaAmbVista,
  },
  data() {
    return {
      cargas: [],
      datoCarga: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      modalWindow: true,
      p_idCarga: 0,
      tramites: [],
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
      showTable: "cargaAmbVista", // Pestaña por defecto
    };
  },
  computed: {
    formattedFechaReg() {
      const originalDate = new Date(this.datoAuto.fechaReg);
      return format(originalDate, "dd/MM/yyyy");
    },
  },

  mounted() {
    this.p_idTramite = this.$route.params.p_idtramite;
    this.p_idCarga = this.$route.params.p_idcarga;
    this.getData();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    getData() {
      api.get("/vwcargas/" + this.p_idCarga)
        .then((response) => {
          this.datoCarga = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener datos de la persona:", error);
        });
    },
  },
};
</script>
<style src="@/assets/css/tabs.css" scoped></style>
